{
  "local": {
    "apiKey": "AIzaSyDBYEE1Cm-ehb497Tn9wR0n3hC0aP728XQ",
    "authDomain": "development1-svc-lo70.firebaseapp.com",
    "projectId": "development1-svc-lo70",
    "storageBucket": "development1-svc-lo70.firebasestorage.app",
    "messagingSenderId": "454445130220",
    "appId": "1:454445130220:web:4bcd0cce0257e4ef6ca0c9",
    "measurementId": "G-WRHG88R9XG"
  },
  "development": {
    "apiKey": "AIzaSyDBYEE1Cm-ehb497Tn9wR0n3hC0aP728XQ",
    "authDomain": "development1-svc-lo70.firebaseapp.com",
    "projectId": "development1-svc-lo70",
    "storageBucket": "development1-svc-lo70.firebasestorage.app",
    "messagingSenderId": "454445130220",
    "appId": "1:454445130220:web:4bcd0cce0257e4ef6ca0c9",
    "measurementId": "G-WRHG88R9XG"
  },
  "production": {
    "apiKey": "AIzaSyDa86fnUAuBeezrJhwrrdG4vrhHYdcClzQ",
    "authDomain": "prod1-svc-lo69.firebaseapp.com",
    "projectId": "prod1-svc-lo69",
    "storageBucket": "prod1-svc-lo69.firebasestorage.app",
    "messagingSenderId": "724138367852",
    "appId": "1:724138367852:web:554905b844a50a231d3149",
    "measurementId": "G-SYKS0G760Q"
  }
}
